// 同时有端内/外打开的情况：
// import { Weblog } from '@ks/weblogger/lib/log.hybrid';

// 只在端内打开的情况，可以使用这个 js（3.9.30 版本支持），体积仅为上边 js 的 30%：
// import { Weblog } from '@ks/weblogger/lib/log.bridge';

// 端外上报：
import { Weblog } from '@ks/weblogger/lib/log.browser';
import Radar from '@ks-radar/radar';

const timeMap = new Map();

const weblog = new Weblog(
  {
    env: 'production', // 正式环境
  },
  {
    product_name: 'xxx', // 在埋点管理平台注册的产品
  },
);
const radar = new Radar({
  weblog,
  projectId: '8b665304ef',
  sampling: 1,
  // 其他参数见下方表格
  customDimensions: {
    release_tag: window.kfxEnv?.channelId,
    product_version: window.kfxEnv?.version,
  },
});
// const webgger = isProduct
//   ? new Weblog({
//       plugins: [
//         new Radar({
//           weblog: weblog as BaseWeblogInstance,
//           projectId: '8b665304ef',
//           sampling: 1,
//           // 其他参数见下方表格
//         }),
//       ],
//     })
//   : null;

export function _tracker(name: string) {
  if (!radar) return;
  radar.event({
    name, // 必填
    event_type: 'normal', // 【可选】
    message: '消息', // 【可选】
    extra_info: window.location.href, // 【可选】
  });
}
export function _actionStart(name: string, extra?: object) {
  if (!radar) return;
  const start = performance.now();
  timeMap.set(name, start);
  radar.action.start({
    name, // 关键动作名
  });
}
export function _actionEnd(name: string, extra?: object) {
  if (!radar) return;
  const last = timeMap.get(name);
  const duration = performance.now() - last;
  radar.action.end({
    name, // 关键动作名
    extra_info: extra, // 【可选】需要是对象
  });
  radar.event(
    {
      name: `${name}耗时`,
    },
    { duration },
  );
  timeMap.delete(name);
}
